import { render } from "./AccountTypeForm.vue?vue&type=template&id=5358e551&scoped=true"
import script from "./AccountTypeForm.vue?vue&type=script&lang=js"
export * from "./AccountTypeForm.vue?vue&type=script&lang=js"

import "./AccountTypeForm.vue?vue&type=style&index=0&id=5358e551&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5358e551"]])

export default __exports__